import Toolbar from '@mui/material/Toolbar';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { DATE_START_CHANGE_REQUEST, DATE_STOP_CHANGE_REQUEST } from '../constants';

export const BlockRequestBanner: FC = () => {
	const now = DateTime.now();
	return (
		<Toolbar
			disableGutters
			sx={{
				backgroundColor: '#fde0de',
				color: '#000000d0',
				fontStyle: 'italic',
				padding: '0 5px 0px 15px',
				zIndex: 1000,
				'@media (min-width: 600px)': {
					minHeight: '56px',
				},
				mb: '8px',
				borderRadius: '12px',
				display: now.day < DATE_STOP_CHANGE_REQUEST ? 'none' : 'flex',
			}}
		>
			<span>
				<b>Monthly subscription change request might be sent before 25 of the current month. </b>
				This feature will be available again on{' '}
				{now
					.plus({ month: 1 })
					.set({
						day: DATE_START_CHANGE_REQUEST,
					})
					.toFormat('yyyy-MM-dd')}
			</span>
		</Toolbar>
	);
};
